import React, { useCallback, useEffect } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { useLocation } from "react-router-dom";
import './landing.css';

const ParticleComponent = () => {
  const location = useLocation(); // Get the current route location

  // Conditional rendering: Only render particles on the home page
  if (location.pathname !== "/") {
    return null;
  }

  return <ParticlesWrapper key={location.pathname} />;
};

const ParticlesWrapper = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    console.log(container);
  }, []);

  // Cleanup function to stop particles animation when unmounted
  useEffect(() => {
    return () => {
      console.log("Cleaning up Particles...");
      // Add any additional cleanup logic if necessary
    };
  }, []);

  return (
    <div className="ParticleContainer">
      <div className="CompanyName">
        <h1>Punjabi Boli</h1>
        <img
          src="https://readme-typing-svg.demolab.com?font=poppins&weight=700&size=32&pause=1000&color=000000&center=true&width=700&lines=Your+Gateway+to+Punjabi+Mastery;Immerse+Yourself+in+Punjabi+Culture;Speak%2C+Read%2C+and+Write+Punjabi"
          alt="Typing SVG"
        />
      </div>
      <Particles
        id="particles-js"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          particles: {
            number: {
              value: 80,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
              value: ["#6836c5", "#a36ce6", "#e1d4f7"],
            },
            shape: {
              type: "circle",
              stroke: {
                width: 0,
                color: "#fff",
              },
              polygon: {
                nb_sides: 5,
              },
            },
            opacity: {
              value: 0.8,
              anim: {
                enable: false,
              },
            },
            size: {
              value: 8,
              random: true,
              anim: {
                enable: false,
              },
            },
            line_linked: {
              enable: true,
              distance: 150,
              color: "#9b85cc",
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 5,
              out_mode: "out",
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: true,
                mode: "grab",
              },
              onclick: {
                enable: true,
                mode: "push",
              },
              resize: true,
            },
            modes: {
              grab: {
                distance: 140,
                line_linked: {
                  opacity: 1,
                },
              },
              bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 8,
                speed: 3,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
              push: {
                particles_nb: 4,
              },
              remove: {
                particles_nb: 2,
              },
            },
          },
          retina_detect: true,
        }}
      />
    </div>
  );
};

export default ParticleComponent;
